import module from 'contabilidad/declaracionIsn/module'

export const schema = {
  empresaId: 'number',
  status: 'number',
}

export class GenerarLayoutServices {
  constructor($http) {
    this.$http = $http
  }

  get (empresaId, presentacionId, periodicidadId, fechaInicial, fechaFinal, regimenFiscal, estadoId) {
    return this.$http.get(`api/empresa/reporte/declaracion/isn`, {
      params: {
        empresaId,
        presentacionId,
        periodicidadId,
        fechaInicial,
        fechaFinal,
        regimenFiscal,
        estadoId,
      },
      download: true,
    })
  }
}

module.service('generarLayout', GenerarLayoutServices)



// WEBPACK FOOTER //
// ./src/contabilidad/declaracionIsn/services/GenerarLayout.js